module.exports = "/_next/static/images/favicon-1437c5701a076a9c230bf1739b9fab6e.ico";